import { TransactionState } from '../models/TransactionState'
import {
  SET_ACTUAL_PAGE,
  SET_PAGE_VISITED,
  SET_SESSION_EXPIRED,
  TransactionActions
} from './actions/transaction.actions'

export function setActualPage(data: string): TransactionActions {
  return {
    type: SET_ACTUAL_PAGE,
    payload: {
      data
    }
  }
}
export function setLastPageVisited(data: string): TransactionActions {
  return {
    type: SET_PAGE_VISITED,
    payload: {
      data
    }
  }
}
export function getActualPage(store: { transaction: TransactionState }): string {
  return store.transaction.actualPage
}
export function getLastPageVisited(store: { transaction: TransactionState }): string {
  return store.transaction.lastPageVisited
}

export function setSessionExpired(data: boolean): TransactionActions {
  return {
    type: SET_SESSION_EXPIRED,
    payload: {
      data
    }
  }
}

const initialState: TransactionState = {
  actualPage: '',
  sessionExpired: false,
  lastPageVisited: ''
}

export default function transactionReducer(
  state = initialState,
  action: TransactionActions
): TransactionState {
  switch (action.type) {
    case SET_ACTUAL_PAGE:
      return {
        ...state,
        actualPage: action.payload.data
      }
    case SET_SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: action.payload.data
      }
    case SET_PAGE_VISITED:
      return {
        ...state,
        lastPageVisited: action.payload.data
      }

    default:
      return state
  }
}
